import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

export interface DialogData {
  text: string;
}

@Component({
  selector: 'eis-gateway-confirmation-dialog-generic',
  templateUrl: './confirmation-dialog-generic.component.html',
  styleUrls: ['./confirmation-dialog-generic.component.scss']
})
export class ConfirmationDialogGenericComponent implements OnInit {
  dialogText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
  }

  ngOnInit(): void {
    this.dialogText = this.data.text;

  }

}
